// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroller {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  overflow-y: scroll;
}

.scroller::-webkit-scrollbar {
  width: 6px;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: transparent;
}

/* Transparent scrollbar for chat-screen */
.thin-scrollbar {
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.thin-scrollbar::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari and Opera */
}

.response-span ul {
  list-style: disc !important;
  margin-left: 5%;
}

.typing-cursor {
  display: inline-block;
  vertical-align: text-bottom;
  margin-left: 1px;
  animation: chat-cursor-blink 1.05s ease-in-out infinite;
  font-weight: 600;
  color: #132961;
  line-height: 1;
}

@keyframes chat-cursor-blink {
  0%,
  45% {
    opacity: 1;
  }

  50%,
  100% {
    opacity: 0.15;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/end-user/chat/pages/chat-screen/chat.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,0CAA0C;AAC1C;EACE,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,uDAAuD;EACvD,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;;IAEE,UAAU;EACZ;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".scroller {\n  scrollbar-width: thin;\n  scrollbar-color: transparent transparent;\n  overflow-y: scroll;\n}\n\n.scroller::-webkit-scrollbar {\n  width: 6px;\n}\n\n.scroller::-webkit-scrollbar-thumb {\n  background-color: transparent;\n}\n\n/* Transparent scrollbar for chat-screen */\n.thin-scrollbar {\n  scrollbar-width: none;\n  /* Firefox */\n  -ms-overflow-style: none;\n  /* IE and Edge */\n}\n\n.thin-scrollbar::-webkit-scrollbar {\n  display: none;\n  /* Chrome, Safari and Opera */\n}\n\n.response-span ul {\n  list-style: disc !important;\n  margin-left: 5%;\n}\n\n.typing-cursor {\n  display: inline-block;\n  vertical-align: text-bottom;\n  margin-left: 1px;\n  animation: chat-cursor-blink 1.05s ease-in-out infinite;\n  font-weight: 600;\n  color: #132961;\n  line-height: 1;\n}\n\n@keyframes chat-cursor-blink {\n  0%,\n  45% {\n    opacity: 1;\n  }\n\n  50%,\n  100% {\n    opacity: 0.15;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
